import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.AppProducts;

export const PreviewChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(RESOURCES.ProductAccordion.Preview)}
      variant="outlined"
      size="small"
    />
  );
};
